import { Inject, Injectable } from '@angular/core';
import { AML_LIMIT_REPOSITORY, AmlLimitsRepository } from '@core/repositories/aml-limits.repository';
import { AmlLimit } from '@shared/interfaces/aml-limit';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AmlLimitsService {
  constructor(
    @Inject(AML_LIMIT_REPOSITORY) protected repository: AmlLimitsRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  add(limit: AmlLimit): Observable<any> {
    return this.repository.add(limit);
  }

  edit(limit: AmlLimit): Observable<any> {
    return this.repository.edit(limit);
  }

  delete(item: any): Observable<any> {
    return this.repository.delete(item);
  }

  segmentWithoutAmlLimits(): Observable<any> {
    return this.repository.segmentWithoutAmlLimits();
  }
}
